<script lang="ts">
  import Compteur from '../../composants/Compteur.svelte'
  import Jauge from '../../composants/Jauge.svelte'
  import Pas from '../../composants/Pas.svelte'
  import type { Atelier } from '../../stores/creation.svelte'

  let { atelier }: { atelier: Atelier } = $props()

  const bareme = $derived(atelier.referentiel.bareme.competences)

  /** De combien avancent les boutons des lignes. Le budget est de 400 : le pas
      de 1 y serait une punition. */
  let pas = $state(5)

  /**
   * Les Compétences visibles : les 27 de base, plus les avancées que la Classe
   * octroie. Les autres avancées n'appartiennent pas au personnage — les
   * afficher inviterait à dépenser dans le vide.
   */
  const visibles = $derived(
    atelier.referentiel.competences.filter(
      (c) => !c.avancee || c.id in atelier.etat.competences_octroyees,
    ),
  )

  const parCarac = $derived(
    atelier.referentiel.caracteristiques.map((carac) => ({
      carac,
      competences: visibles.filter((c) => c.carac === carac.id),
    })),
  )

  const octroi = (id: string) => atelier.etat.competences_octroyees[id] ?? bareme.valeur_de_depart
  const brute = (id: string) => atelier.feuille.competences[id] ?? octroi(id)
  const reelle = (id: string) => atelier.etat.apercu.competences[id] ?? 0
</script>

<p class="chapo">
  {bareme.augmentations} Augmentations à répartir, plafond {bareme.plafond_a_la_creation}
  par Compétence. La Valeur réelle affichée à droite est la brute plus la
  Caractéristique — c'est elle qu'on teste. Les valeurs se saisissent aussi au
  clavier.
</p>

<div class="cartouche">
  <div class="bandeau">Augmentations de Compétence</div>
  <div class="corps">
    <Jauge
      budget={atelier.etat.competences.budget}
      depense={atelier.etat.competences.depense}
    />
    <div class="reglages">
      <Pas {pas} onchange={(v) => (pas = v)} />
    </div>
  </div>
</div>

{#if !atelier.feuille.classe}
  <p class="note">
    Choisissez d'abord une Classe : elle octroie des Compétences avancées, à une
    Valeur brute que le budget ne paie pas.
  </p>
{/if}

<div class="familles">
  {#each parCarac as famille (famille.carac.id)}
    <section class="cartouche">
      <div class="bandeau">{famille.carac.nom}</div>
      <div class="corps">
        {#each famille.competences as c (c.id)}
        {@const plancher = octroi(c.id)}
        <div class="ligne" class:avancee={c.avancee}>
          <span class="nom">
            {c.nom}
            {#if c.avancee}<span class="badge rang" title="Octroyée par la Classe">Classe</span>{/if}
          </span>
          <Compteur
            valeur={brute(c.id)}
            min={plancher}
            max={atelier.etat.plafond_de_competence}
            libelle={c.nom}
            {pas}
            onchange={(v) => atelier.fixerCompetence(c.id, v)}
          />
          <span class="reelle data" title="Valeur réelle : brute + Caractéristique">
            {reelle(c.id)}
          </span>
        </div>
        {/each}
      </div>
    </section>
  {/each}
</div>

<style>
  .chapo {
    color: var(--ink-soft);
    max-width: 62ch;
    margin: 0 0 calc(var(--pas) * 4);
  }
  .note {
    color: var(--gold);
    font-size: 0.9rem;
  }
  .reglages {
    display: flex;
    justify-content: flex-end;
  }
  .familles {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(20rem, 1fr));
    gap: calc(var(--pas) * 4);
    margin-top: calc(var(--pas) * 4);
  }
  .ligne {
    display: grid;
    grid-template-columns: 1fr auto 2.5rem;
    align-items: center;
    gap: calc(var(--pas) * 2);
    padding: calc(var(--pas) * 1.5) 0;
  }
  .ligne + .ligne {
    border-top: 1px solid var(--line);
  }
  .nom {
    font-size: 0.9rem;
  }
  .badge {
    font-size: 0.55rem;
    padding: 1px 7px;
    margin-left: var(--pas);
  }
  .reelle {
    text-align: right;
    font-weight: 600;
  }
</style>
